var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73001 5.90332C7.40736 6.60612 8.21949 7.1651 9.11783 7.54683C10.0162 7.92856 10.9823 8.1252 11.9583 8.12499C12.9469 8.12527 13.9252 7.92394 14.8333 7.53332",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 8.125C6.125 9.28532 6.58594 10.3981 7.40641 11.2186C8.22688 12.0391 9.33968 12.5 10.5 12.5C11.6603 12.5 12.7731 12.0391 13.5936 11.2186C14.4141 10.3981 14.875 9.28532 14.875 8.125C14.875 6.96468 14.4141 5.85188 13.5936 5.03141C12.7731 4.21094 11.6603 3.75 10.5 3.75C9.33968 3.75 8.22688 4.21094 7.40641 5.03141C6.58594 5.85188 6.125 6.96468 6.125 8.125V8.125Z",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2608 17.3968C15.506 16.6372 14.6084 16.0344 13.6198 15.6231C12.6311 15.2118 11.5708 15 10.5 15C9.42917 15 8.36891 15.2118 7.38023 15.6231C6.39156 16.0344 5.49398 16.6372 4.73917 17.3968",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 10C1.125 12.4864 2.11272 14.871 3.87087 16.6291C5.62903 18.3873 8.0136 19.375 10.5 19.375C12.9864 19.375 15.371 18.3873 17.1291 16.6291C18.8873 14.871 19.875 12.4864 19.875 10C19.875 7.5136 18.8873 5.12903 17.1291 3.37087C15.371 1.61272 12.9864 0.625 10.5 0.625C8.0136 0.625 5.62903 1.61272 3.87087 3.37087C2.11272 5.12903 1.125 7.5136 1.125 10V10Z",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.0ea78543b1bd6a59b5b17abe0c82fc7f.svg";
export { ForwardRef as ReactComponent };